// extracted by mini-css-extract-plugin
export default {"root":"LogDetailModal_root__rZhZg","box":"LogDetailModal_box__7O64W"};